import React from 'react';
import './landing.css';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { fetchAuthSession, signInWithRedirect, signOut } from 'aws-amplify/auth';

const Landing = () => {
        const navigate = useNavigate();
    
    
        useEffect(() => {
                async function handleAuthentication() {
                    fetchAuthSession().then(async authSession=>{
                        if(authSession?.tokens?.accessToken){
                            navigate("/dash")
                        }else{
                            console.log("Authentication Failed");
                        await signInWithRedirect();

                        }
                    },async ()=>{
                        console.error("Authentication Failed");
                        await signInWithRedirect();
                    });
        
                }
        
                handleAuthentication();

    })
    return (
        <></>
    )
}

export default Landing